module.exports = __webpack_public_path__ + "static/media/lightTheme.afd3f241.jpg";